import { useState } from "react";
import { Type, Check } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { TEXT_SIZES, setTextSize, useTextSize } from "@/lib/textSize";

export const TextSizeControl = ({ context = "header" }) => {
  const [open, setOpen] = useState(false);
  const value = useTextSize();
  const active = TEXT_SIZES.find((size) => size.id === value);
  const selectSize = (id) => { setTextSize(id); setOpen(false); };
  return <Popover open={open} onOpenChange={setOpen}>
    <PopoverTrigger asChild>
      <button type="button" data-testid={`${context}-text-size-button`} aria-label={`Text size: ${active.label}`} title="Text size" className="text-size-trigger">
        <Type size={22} aria-hidden="true" /><span>Text size</span>
      </button>
    </PopoverTrigger>
    <PopoverContent align="end" className="text-size-popover" data-testid={`${context}-text-size-menu`} data-lenis-prevent>
      <fieldset>
        <legend className="font-serif text-lg font-semibold text-midnight" data-testid={`${context}-text-size-title`}>Text size</legend>
        <div className="mt-3 grid gap-2">
          {TEXT_SIZES.map((size) => <label key={size.id} className={`text-size-option ${value === size.id ? "is-selected" : ""}`}>
            <input type="radio" name={`${context}-text-size`} value={size.id} checked={value === size.id} onChange={() => selectSize(size.id)} onClick={() => { if (value === size.id) setOpen(false); }} data-testid={`${context}-text-size-${size.id}`} />
            <span>{size.label}</span><span className="ml-auto text-sm" aria-hidden="true">{size.scale}</span>{value === size.id && <Check size={18} aria-hidden="true" />}
          </label>)}
        </div>
      </fieldset>
    </PopoverContent>
  </Popover>;
};